import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseComponent } from 'src/app/_base/base.component';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent extends BaseComponent implements OnInit {
  @Input()
  header: string = null;
  @Input()
  confirmMessage: string = null;
  @Output()
  delete = new EventEmitter<null>();
  constructor(private modalRef: BsModalRef) {
    super();
   }

  ngOnInit() {
  }
  deleting(): void {
    this.delete.emit();
  }
  modalClose(): void {
    this.modalRef.hide();
  }
}
